import ServiceManager from '../../service/ServiceManager';
import { data } from '../../constants/Constants';
import { getDevice } from './utilApi';



export function getTransportista(CodigoDealer, CorreoElectronico, VKorg, Region, LocalId) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/BuscarTransportista";
    params.data = {
        'dto.CodigoDealer': CodigoDealer,
        'dto.VKorg': VKorg,
        'dto.DispositivoDealer': DispositivoId,
        'dto.CorreoElectronicoDealer': CorreoElectronico,
        'dto.Region': Region,
        'dto.Sistema': data.Sistema,
        'dto.LocalId': LocalId
    };
    console.log("getTransportista====>", params.data);
    return ServiceManager.prototype.Post(params);
}